import { ImageItemInterface } from '@/types/newTypes'
import React from 'react'
import { useTheme } from '@/components/ThemeProvider'

const ImageGridThreeBrand = () => {
  const { theme } = useTheme()

  const items: ImageItemInterface[] = [
    {
      img: '/img/they-write-about-us/1.png',
    },
    {
      img: theme === 'light' ? '/img/they-write-about-us/2.png' : '/img/they-write-about-us/2.png',
    },
    {
      img: '/img/they-write-about-us/3.png',
    },
  ]

  return (
    <section className="">
      <div className="flex flex-col gap-6 mb-8 p-6 rounded-4xl bg-[#D4D9FF] dark:bg-transparent dark:bg-grayGradient">
        <h2 className="font-semibold text-XL leading-[1.35] text-center text-[#070D7A] dark:text-white">
          They write about us
        </h2>
        <div className="flex justify-between items-center">
          {items.map((item, index) => (
            <img
              src={item.img}
              alt="They write about us"
              key={index}
              className="block h-[50px] max-w-full"
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default ImageGridThreeBrand
